module.exports = __webpack_public_path__ + "img/emoji_ksc.01a5085b.png";